import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { ApiError, ConfigServerService, JwtService, MessageService } from '../../../../core';
import type { IAvatarSettings } from '../../../../domains/shared/components/avatar/avatar.component';
import { UsuarioFileManagerService } from '../../services';
import { Usuario } from '../../usuario';
import { UsuarioAvatarService } from '../services';

@Component({
    selector: 'sgt-usuario-avatar-upload',
    templateUrl: './usuario-avatar-upload.component.html',
    styleUrls: ['./usuario-avatar-upload.component.less']
})
export class UsuarioAvatarUploadComponent implements OnInit {
    @Input() entity: Usuario;

    @ViewChild('inputFile') inputFile: ElementRef;
    @ViewChild('usuarioAvatarContainer') usuarioAvatarContainer: ElementRef;
    uploader: FileUploader;
    isUploading = false;

    avatarSettings: IAvatarSettings;

    constructor(private configServerService: ConfigServerService,
                private jwtService: JwtService,
                private messageService: MessageService,
                private usuarioFileManagerService: UsuarioFileManagerService,
                private usuarioAvatarService: UsuarioAvatarService) { }

    ngOnInit() {
        this.create();

        this.avatarSettings = {
            fullName: this.entity?.nome,
            imageUrl: this.entity?.avatarUrl,
            size: 100,
        };
    }

    /** Cria o uploader para realizar o upload da imagem do avatar */
    private create() {
        this.uploader = new FileUploader({
            method: 'PUT',
            url: `${this.configServerService.getPathApi()}/usuario/${this.entity.id}/avatar`,
            authToken: this.jwtService.accessTokenWithBearer,
            autoUpload: true
        });

        this.onAfterAddingFile();
        this.onProgressItem();
        this.onCompleteItem();
    }

    /** Após selecionar o arquivo da imagem */
    private onAfterAddingFile() {
        this.uploader.onAfterAddingFile = (fileItem: FileItem): any => {
            this.hideDropdown();
            fileItem.withCredentials = false;
             // Gerando a visualiza temporária da imagem selecionada
            //  const reader = new FileReader();
            //  reader.readAsDataURL(fileItem._file);
            //  reader.onload = (e: any) => {
            //      this.entity.avatarUrl = e.target.result;
            //  }
        }
    }

    private onProgressItem() {
        this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
            this.isUploading = true;
        };
    }

    /** Ao completar o upload */
    private onCompleteItem() {
        this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
            switch (status) {
                case 200: // OK
                    this.entity.avatarUrl = response;
                    this.usuarioAvatarService.next(this.entity.avatarUrl);
                    break;
                default: // Demais erros
                    const error = JSON.parse(response) as ApiError;
                    this.messageService.error(error.message, 'Erro ao realizar o upload da foto de perfil', error);
                    break;
           }

           this.isUploading = false;
           this.clearInputFile();
       };
    }

    /** Limpa o input file */
    private clearInputFile() {
        const el = this.inputFile.nativeElement as HTMLInputElement;
        el.value = '';
    }

    /** Esconde o dropdown com as opções do avatar */
    private hideDropdown() {
        // Simulando um clique fora do dropdown por que utilizando o método hide não funciona realizar o upload mais de uma vez em seguida
        jQuery(this.usuarioAvatarContainer?.nativeElement).trigger('click');
    }

    /** Ao clicar no avatar executamos a opção de selecionar a imagem */
    onClickAvatar() {
        jQuery(this.inputFile?.nativeElement).trigger('click');
    }

    /** Exclui a imagem do avatar */
    delete() {
        // Removendo do servidor
        this.usuarioFileManagerService.deleteAvatar(this.entity.id)
            .subscribe(
                () => {
                    this.entity.avatarUrl = null;
                    this.usuarioAvatarService.next(this.entity.avatarUrl);
                    this.clearInputFile();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao excluir a foto de perfil', error)
            );
    }
}
